import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { IgxGridComponent } from '@infragistics/igniteui-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Color } from 'igniteui-angular-core';
import {
  CellBorderLineStyle,
  CellFill,
  HorizontalCellAlignment,
  IWorkbookFont,
  VerticalCellAlignment,
  Workbook,
  WorkbookColorInfo,
  WorkbookFormat,
} from 'igniteui-angular-excel';
import { Subject, combineLatest } from 'rxjs';
import {
  filter,
  first,
  map,
  switchMap,
  take,
  takeUntil,
  tap,
  withLatestFrom
} from 'rxjs/operators';
import { AdobelaunchService } from '../../_services/adobelaunch.service';
import { AppService } from '../../app.service';
import { ConfirmDialogService } from '../../confirm-dialog/confirm-dialog.service';
import { ExcelUtility } from '../../shared/ExcelUtility';
import { PDFService, printParams } from '../../shared/pdf.service';
import { ToastService } from '../../shared/toast.service';
import { userdefinedParams } from '../../shared/userdefinedservice';
import { Labels } from '../../shared/labels';
import { CompanyService } from '../company.service';
import * as GridActions from '../grid-configuration/data-access/grid-config.actions';
import { UploadPremiumComponent } from '../upload-premium/upload-premium.component';
import * as premiumReportActions from './data-access/premium-report.action';
import { PremiumReportState } from './data-access/premium-report.models';
import {
  columnsSelector,
  currentCellFormulaSelector,
  currentCellNameSelector,
  currentGridDataSelector,
  currentGridTypeSelector,
  currentGridisValid,
  errorMessageSelector,
  errorStateSelector,
  hiddenPremiumCountSelector,
  isGridDirty,
  isLoadingStateSelector,
  isLockForValidationSelector,
  isOtherGridDirty,
  isPrfLocked,
  rowsSelector,
  selectPremiumReportState,
  userDefinedPremiumColumnSelector,
  userDefinedPremiumDataSelector,
} from './data-access/premium-report.selectors';
import {
  Premiumreportservice,
  premiumreportParams,
} from './data-access/services/premiumreportservice';
import { cleanPremiumData } from './data-access/utilities/premiumcount.utility';
import { DownloadPremiumComponent } from '../download-premium/download-premium.component';
import { ConvetToThousandsService } from '../convettothousands.service';
import { ValidationSummaryService } from '../validation-summary/data-access/validation-summary-service';
import { selectGroupCode, selectPrfName, selectPrfNumber, selectPrfYear } from 'src/app/store/selectors/app.selector';
import { selectAllConfigurationsLoaded, selectDirectPremiumColumnsWithTotal } from '../grid-configuration/data-access/grid-config.selectors';

@Component({
    selector: 'app-premium-report',
    templateUrl: './premium-report.component.html',
    styleUrls: ['./premium-report.component.scss'],
    standalone: false
})
export class PremiumReportComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private subscriptions: Subject<void> = new Subject<void>();
  @ViewChild('grid1', { read: IgxGridComponent, static: true })
  public grid1: IgxGridComponent;
  listenerFn: () => void;
  public direct_premium: any[];
  public supplemental_premium: any[];
  public userdefined_premium: any[];
  public userdefined_premium_columns: any[];
  public userdefined_premium_supplemental: any[];
  public direct_premium_copy: any[];
  public supplemental_premium_copy: any[];
  public columns: any[];
  public rows: any[];
  FORMULATED_COLUMNS: number[] = [];
  LOCKED_COLUMNS: number[] = [];
  EXCEPTED_COLUMNS: number[] = [];
  isFullscreen = false;
  isLockForValidation: boolean = false;
  public supplemental_premium$ = this.store.select(
    currentGridDataSelector('S')
  );
  public direct_premium$ = this.store.select(currentGridDataSelector('D'));
  data: any;
  public userdefined_premium_direct$ = this.store.select(
    userDefinedPremiumDataSelector('D')
  );
  public userdefined_premium_columns$ = this.store.select(
    userDefinedPremiumColumnSelector
  );
  public userdefined_premium_supplemental$ = this.store.select(
    userDefinedPremiumDataSelector('S')
  );

  public cellName$ = this.store.select(currentCellNameSelector).pipe(
    tap((x) => {
      console.log(x);
    })
  );
  public cellFormula$ = this.store.select(currentCellFormulaSelector);
  public premium_type: 'D' | 'S' = 'D';
  public premium_type$ = this.store.select(currentGridTypeSelector);

  private isDirty = false;
  public showPageError$ = this.store.select(errorStateSelector);
  public showPageWarning = false;
  private isvalidgrid = true;
  public errorMsg$ = this.store.select(errorMessageSelector);
  public warningMsg = '';
  premiumreportparams: premiumreportParams;
  userdefinedparams: userdefinedParams;
  compno: any;
  groupcode: any;
  currentYear: number;
  prfNumber: string;
  prfName: string;
  isLocked: boolean;
  isReadOnly: boolean;
  isReadOnlyAdmin: boolean;
  isAdmin: boolean = false;
  user: string;
  isLoading: boolean = false;
  isLoading$ = this.store.select(isLoadingStateSelector);
  allConfigurationsLoaded$ = this.store.select(selectAllConfigurationsLoaded);
  isDownloading: boolean = false;
  isComplete: boolean = true;
  isUpload: boolean = false;
  UnEditableCellInfo: object = {};
  IsUnEditableWithTab: boolean = false;
  isTypingOverGridCell = false;
  prevGridCellValue = '';
  selectText: boolean = true;
  hiddenPremiumCount: { rows: number, columns: number } = { 'rows': 0, 'columns': 0 };
  isLegacyDownload: boolean = false;
  public columns$ = this.premium_type$.pipe(
    switchMap((premium_type) => {
      return this.store.select(columnsSelector(premium_type));
    })
  );
  public rows$ = this.store.select(rowsSelector);
  public options = {
    enabled: true,
    copyHeaders: false,
    copyFormatters: true,
    separator: '\t',
  };

  setDataForGrid(data: any[], grid: 'D' | 'S' = this.premium_type) {
    this.store.dispatch(
      premiumReportActions.setGridPremiumData({
        grid: grid,
        premiumData: data,
      })
    );
  }
  hasUnsavedData() {
    return this.isDirty;
  }

  constructor(
    private companyService: CompanyService,
    private modalService: NgbModal,
    public toastService: ToastService,
    private pdfService: PDFService,
    private confirmDialogService: ConfirmDialogService,
    private appService: AppService,
    private router: Router,
    private premiumReportService: Premiumreportservice,
    private adobeLaunchService: AdobelaunchService,
    private store: Store,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private converttothousandsService: ConvetToThousandsService,
    private validationSummaryService: ValidationSummaryService
  ) { }

  ngAfterViewInit() {
    this.adobeLaunchService.EventEndDispatch();
    const exitDivs = document.querySelectorAll('.exitFS');
    exitDivs.forEach(div => {
      this.renderer.listen(div, 'click', () => this.exitFullscreen());
    });
  }

  openFullscreen(): void {
    const container = this.elementRef.nativeElement.querySelector('#grid-container');
    if (container.requestFullscreen) {
      this.resetScrollPositions();
      setTimeout(() => {
        container.requestFullscreen();
      }, 200)
    }
  }
  exitFullscreen() {
    if (document.exitFullscreen) {
      this.resetScrollPositions();
      document.exitFullscreen(); 
    }
  }

  @HostListener('document:fullscreenchange')
  onFullscreenChange(): void {
    this.isFullscreen = !!document.fullscreenElement;
  }

  @HostListener('document:keydown.f', ['$event'])
  onFKeyPressed(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
      this.openFullscreen();
    }
  }

  private resetScrollPositions(): void {
    const horizontalElement = this.elementRef.nativeElement.querySelector('.igx-vhelper--horizontal');
    const verticalElement = this.elementRef.nativeElement.querySelector('.igx-vhelper--vertical');
    this.renderer.setProperty(horizontalElement, 'scrollLeft', 0);
    this.renderer.setProperty(verticalElement, 'scrollTop', 0);
  }

  ngOnInit() {
    this.removePrevAlerts();
    this.isAdmin = this.appService.isAdmin;
     this.store.select(selectPrfName).subscribe(prfName => {
                  this.prfName = prfName;
                });
             
                this.store.select(selectPrfNumber).subscribe(prfNumber => {
                  this.prfNumber = prfNumber || '';
                  this.compno = prfNumber || '';
                });
            
                 this.store.select(selectPrfYear).subscribe(year => {
                  this.currentYear = year;
                });
            this.store.select(selectGroupCode).subscribe(groupCode => {
                  this.groupcode = groupCode;
                  if (!this.groupcode) {
                    this.companyService.getgroup().subscribe((value) => {
                      this.groupcode = value;
                    });
                  }
                });
    this.prfName = this.companyService.prfName;
    this.isLocked = this.companyService.isEditLocked;
    this.isReadOnlyAdmin = this.appService.isReadonlyAdmin;

    this.isReadOnly = this.isLocked || this.isReadOnlyAdmin;
    this.loadColumnConfig();
    this.companyService.getPrfStatus();
    this.premium_type$
      .pipe(
        switchMap((premium_type) => {
          return this.store.select(isGridDirty(premium_type));
        })
      )
      .subscribe((x) => {
        this.isDirty = x;
      });
    this.premium_type$
      .pipe(
        switchMap((premium_type) => {
          return this.store.select(currentGridisValid(premium_type));
        })
      )
      .subscribe((x) => {
        this.isvalidgrid = x;
      });
    this.columns$.subscribe((col) => {
      console.log(col);
      this.columns = col;
    });
    this.rows$.subscribe((rows) => {
      this.rows = rows;
    });
    this.premium_type$.subscribe((gridType) => {
      this.premium_type = gridType;
    });
    this.supplemental_premium$.subscribe((x) => {
      this.supplemental_premium = x;
    });
    this.store.select(isOtherGridDirty).subscribe((isDirty) => {
      if (isDirty) {
        this.showSaveChangesDialog(
          this.premium_type == 'D' ? 'direct' : 'supplemental'
        );
      }
    });
    this.premium_type$
      .pipe(
        switchMap((premium_type) => {
          return this.store.select(hiddenPremiumCountSelector(premium_type));
        })
      )
      .subscribe((obj) => {
        this.hiddenPremiumCount = obj;
      });

      combineLatest([
        this.store.select(isLockForValidationSelector),
        this.store.select(isPrfLocked),
      ]).subscribe(([isValidationLocked, prfLocked]) => {
        this.isLockForValidation = isValidationLocked;
        console.log(
          'updated',
          isValidationLocked,
          localStorage.getItem('isLocked') == 'true'
        );

        this.isLocked = prfLocked || isValidationLocked;
        this.isReadOnly = this.isLocked || this.appService.isReadonlyAdmin;
        console.log(this.isLocked);
      });
  }

  private LoadData() {
    this.store.dispatch(
      premiumReportActions.loadPremiumInfo({
        compno: this.compno,
        currentYear: this.currentYear,
        groupcode: this.groupcode,
      })
    );
  }

  private showError(msg) {
    this.store.dispatch(premiumReportActions.setError({ message: msg }));
    console.error('error set from base');
  }

  private showWarning(msg) {
    this.showPageWarning = true;
    this.warningMsg = msg;
    setTimeout(() => {
      this.showPageWarning = false;
      this.warningMsg = '';
    }, 5000);
  }

  clickToUnLock(): void {
    const inputData = {
      prfuser: this.companyService.userid,
      year: this.currentYear,
      companyNumber: this.compno,
      groupCode: this.groupcode,
      dummyrpt: false
    };

    this.validationSummaryService.unlockToEdit(inputData).subscribe({
      next: (response: any) => {
        if (response) {
          this.toastService.show('PRF unlocked for editing successfully', {
            classname: 'bg-success text-light',
            delay: 3000
          });

          this.isLockForValidation = false;
          this.isLocked = false;
          this.isReadOnly = false;

          this.store.dispatch(premiumReportActions.updateLockStatus());
        }
      },
      error: (error) => {
        console.error('Error unlocking page:', error);
        this.router.navigate(['/apifailure']);
      }
    });
  }

  private clearError() {
    this.store.dispatch(premiumReportActions.clearError());
  }

  public downloadtemplate() {
    this.companyService.getPremiumReportTemplateFile('Template.xlsx').subscribe({
      next: (resp) => {
        if (resp['message'] == 'Success') {
          let fileurl = resp['data'];
          window.open(fileurl, '_blank', 'noopener noreferrer');
        }
      },
      error: () => {
        this.router.navigate(['/apifailure']);
      }
    });
  }

  public updatePremiumDetails(premium_type = this.premium_type) {
    setTimeout(() => {
      // Adding delay to wait for grid update to complete
      this.toastService.reset();
      this.store.dispatch(
        premiumReportActions.setGridClean({ grid: premium_type })
      );
      this.handlePremiumDetailsUpdate(premium_type);
    }, 500);
  }

  private handlePremiumDetailsUpdate(premium_type: 'D' | 'S') {
    this.store
      .select(selectPremiumReportState)
      .pipe(take(1))
      .subscribe((data: PremiumReportState) => {
        const griddata = {
          premreportlobs: data.columns[premium_type],
          premreportstates: data.rows,
          dpremiuminfo: data.premiumData.D.premiumGridData,
          spremiuminfo: data.premiumData.S.premiumGridData,
          udpremiuminfo: data.userDefinedPremiumData.D,
          uspremiuminfo: data.userDefinedPremiumData.S,
          udlobs: data.userDefinedPremiumDataColumns,
        };
        this.companyService.disableCompanyList.next(true);
        this.companyService.clearStatus();

        this.companyService
          .updatepremiumdetails(
            this.currentYear,
            this.compno,
            griddata,
            this.groupcode,
            false,
            this.isUpload
          )
          .pipe(takeUntil(this.subscriptions))
          .subscribe({
            next: (resp) => this.handleUpdateSuccess(resp, premium_type),
            error: (error) => this.handleUpdateError(error, premium_type),
          });
      });
  }

  private handleUpdateSuccess(resp: any, premium_type: 'D' | 'S') {
    if (resp['message'] === 'Success') {
      this.toastService.reset();
      this.store.dispatch(
        premiumReportActions.setGridClean({ grid: premium_type })
      );
      this.store.dispatch(
        premiumReportActions.refreshCopyWithCurrent()
      );

      const message = this.isUpload
        ? 'File Uploaded Successfully.'
        : 'Premium saved successfully.';
      this.toastService.show(message, {
        classname: 'bg-success text-light',
        delay: this.isUpload ? 5000 : 3000,
      });

      this.isUpload = false;
      this.companyService.disableCompanyList.next(false);
      this.companyService.getPrfStatus();
      setTimeout(() => {
        this.toastService.reset();
      }, 5000);
    }
  }

  private handleUpdateError(error?: any,premium_type: 'D' | 'S' = this.premium_type) {
    // Check for specific "Data missmatch" response
    console.log("Error:", error);
    if (error?.error?.message === "Data missmatch") {
      // Show popup for data mismatch case
      this.confirmDialogService.confirmThis_withClose(
        'Unable to Save Data',
        'An unexpected error occurred while saving your data. Please refresh the page to resolve this issue. If the problem persists, contact your system administrator.<br><strong>Note: Any unsaved changes will be lost upon refresh.</strong> Would you like to refresh now?',
        () => {
          // OK button - refresh page
          window.location.reload();
        },
        () => {
          this.store.dispatch(
        premiumReportActions.setGridDirty({ grid: premium_type })
          );
          this.store.dispatch(
        premiumReportActions.refreshCopyWithCurrent()
          );
          this.companyService.disableCompanyList.next(false);
          this.companyService.getPrfStatus();
        },
        () => {
          // Close button - do nothing  
          return;
        }
      );
      return;
    }

    // Default behavior for other errors
    this.store.dispatch(
      premiumReportActions.setGridDirty({ grid: this.premium_type })
    );
    this.router.navigate(['/apifailure']);
  }

  public uploadExcelDataToGrid(uploadedFile) {
    if (!uploadedFile) {
      this.showError('Please select a file to Upload!');
      return false;
    }
    const fileExt = uploadedFile.name.split('.').pop();
    if (fileExt !== 'xlsx') {
      this.showError('Invalid file selected, valid files are of .xlsx types.');
      return false;
    }

    this.showWarning(
      'Please Wait! File upload will take some time.\nYou will get an upload status at end.\nAlso make sure that you are using the correct file for uploading premiums for the company ' +
      this.compno +
      '.'
    );

    ExcelUtility.load(uploadedFile).then((w) => {
      this.uploadPremium(w);
    });
  }

  private validateLOBs(worksheet) {
    for (let col = 0; col < this.columns.length; col++) {
      if (col === 0) {
        continue;
      }
      const column = this.columns[col];
      const excelLob = worksheet.rows(0).cells(col).value;
      if (
        excelLob !== null &&
        column.columnName.replace(/\r?\n|\r|\s/g, '') !==
        excelLob.replace(/\r?\n|\r|\s/g, '')
      ) {
        this.showError(
          'LOB Header in col [' +
          (col - 2) +
          '] is invalid. Please use the template file for upload.'
        );
        return false;
      }
    }
    return true;
  }

  public Clear(flag = false) {
    if (this.isDirty || flag) {
      this.store.dispatch(premiumReportActions.refreshDirectWithCopy());
      this.store.dispatch(premiumReportActions.refreshSupplementalWithCopy());
    }
  }

  private uploadPremium(workbook) {
    // to check original template.xlsx file is uploaded.
    if (!this.validateWorkbook(workbook)) {
      return;
    }
    // Rename the uploaded template sheets to the current labels before processing.
    workbook.worksheets(0).name = Labels.premium.directPlural;
    workbook.worksheets(1).name = Labels.premium.supplementalPlural;
    const sheetCount = workbook.worksheets().count;

    combineLatest([this.direct_premium$, this.supplemental_premium$])
      .pipe(take(1))
      .subscribe(([direct_premium, supplemental_premium]) => {
        for (let sheet = 0; sheet < sheetCount; sheet++) {
          const worksheet = workbook.worksheets(sheet);
          // Validate the structure of the uploaded template
          if (!this.validateWorksheet(worksheet)) {
            this.Clear(true);
            return false;
          }
          if (!this.processWorksheet(worksheet, sheet, direct_premium, supplemental_premium)) {
            this.Clear(true);
            return false;
          }
        }
        this.finalizeUpload(direct_premium, supplemental_premium);
      });
  }
  private validateWorkbook(workbook): boolean {
    if (!this.validateA1Cell(workbook)) {
      return false;
    }

    if (workbook.worksheets().count !== 2) {
      this.showError(
        `Invalid File. File contains [${workbook.worksheets().count}] Sheet(s)! Download the Template.`
      );
      return false;
    }

    if (
      !this.isAdmittedSheetName(workbook.worksheets(0).name) ||
      !this.isNonAdmittedSheetName(workbook.worksheets(1).name)
    ) {
      this.showError(
        'Invalid Sheet Names! First sheet name should be [Admitted Premiums] and second sheet name should be [Non-Admitted Premiums]. Download the Template.'
      );
      return false;
    }

    return true;
  }

  private isAdmittedSheetName(name: string): boolean {
    // Accept the current name and the legacy name so customers can still
    // upload older templates in the premium grid.
    return name === 'Admitted Premiums' || name === 'Direct Premiums';
  }

  private isNonAdmittedSheetName(name: string): boolean {
    // Accept the current name and the legacy name so customers can still
    // upload older templates in the premium grid.
    return name === 'Non-Admitted Premiums' || name === 'Supplemental Premiums';
  }
  private validateWorksheet(worksheet): boolean {
    const expectedColumns = this.columns.length;
    const expectedRows = this.rows.length;

    if (!this.validateTemplateStructure(worksheet, expectedRows, expectedColumns)) {
      return false;
    }

    if (!this.validateFormulaCells(worksheet, this.FORMULATED_COLUMNS, this.premiumReportService.FORMULATED_ROWS)) {
      return false;
    }

    if (!this.validatelockedCells(worksheet, this.LOCKED_COLUMNS, this.premiumReportService.LOCKED_ROWS)) {
      return false;
    }

    return true;
  }

  private finalizeUpload(direct_premium, supplemental_premium): void {
    this.setDataForGrid(direct_premium, 'D');
    this.setDataForGrid(supplemental_premium, 'S');
    this.isUpload = true;
    this.updatePremiumDetails();
    this.clearError();
  }

  private getCellValue(worksheet, rowIndex, col, slno): any {
    if (col < this.premiumReportService.FIXED_COLUMNS) {
      return this.getFixedColumnValue(worksheet, rowIndex, col, slno);
    } else {
      return this.getDynamicColumnValue(worksheet, rowIndex, col);
    }
  }

  private getFixedColumnValue(worksheet, rowIndex, col, slno): any {
    const value = worksheet.rows(rowIndex).cells(col).value;
    if (col === this.premiumReportService.CONST_SLNO_COLUMN) {
      if (parseInt(value) === slno) {
        return value;
      } else {
        this.showError(`SL No mismatch. Invalid template in sheet ${worksheet.name}. Use original template file.`);
        return false;
      }
    }

    return value;
  }

  private getDynamicColumnValue(worksheet, rowIndex, col): any {
    let value = worksheet.rows(rowIndex).cells(col).value != null &&
                worksheet.rows(rowIndex).cells(col).value != ''
                ? worksheet.rows(rowIndex).cells(col).value
                : null;

    if (isNaN(value)) {
      this.showError(`Invalid data! Non-numeric value found in column ${col + 1} at row ${rowIndex + 1}`);
      return false;
    }

    value = value != null ? Math.round(parseFloat(value)) : null;

    if (parseInt(value) > 99999999 || parseInt(value) < -99999999) {
      this.showError('Upload cell value cannot be greater than 99,999,999 or less than -99,999,999.');
      this.store.dispatch(premiumReportActions.setGridDirty({ grid: this.premium_type }));
      return false;
    }

    return value;
  }
  
  private processWorksheet(worksheet, sheet, direct_premium, supplemental_premium): boolean {
    let slno = 6;
    
    if (!this.validateLOBs(worksheet)) {
      return false;
    }

    let i = 1;
    do {
    const result = this.processRow(worksheet, i, sheet, slno, direct_premium, supplemental_premium);
    if (result === false) {
      return false;
    }
    slno = result; // updated slno
    i++;
    } while (worksheet.rows(i).cells(0).value != null);

    return true;
  }

  private processRow(worksheet, rowIndex, sheet, slno, direct_premium, supplemental_premium): any {

    // For the direct sheet, set cell B66 to the supplemental volume label before processing.
    
    if (sheet === 0 && rowIndex === 65) {
      worksheet.rows(65).cells(1).value = Labels.premium.supplementalVolume;
    }

    let stateCode = '';
    let stateDesc = '';

    for (let col = 0; col < this.columns.length; col++) {
      const value = this.getCellValue(worksheet, rowIndex, col, slno);
      if (value === false) {
        return false;
      }
      // Increment slno if column is SLNO
      if (this.isSLNOColumn(col)) {
        slno++;
      }

      if (col === this.premiumReportService.CONST_STATE_COLUMN) {
        stateDesc = value;
      } else if (col === this.premiumReportService.CONST_STATECODE_COLUMN) {
        stateCode = value;
      }

      if (col === this.premiumReportService.CONST_STATECODE_COLUMN && !this.isValidState(stateCode, stateDesc, sheet)) {
        return false;
      }
      
      if (stateCode === this.premiumReportService.userdefined_row_code) {
        break;
      }

      this.updatePremiumData(sheet, rowIndex, col, value, direct_premium, supplemental_premium);
    }

    return slno;
  }

  private updatePremiumData(sheet, rowIndex, col, value, direct_premium, supplemental_premium): void {
    if (sheet === 0 && direct_premium[rowIndex - 1] != null) {
      direct_premium[rowIndex - 1][col] = value;
    } else if (sheet === 1 && supplemental_premium[rowIndex - 1] != null) {
      supplemental_premium[rowIndex - 1][col] = value;
    }
  }
  private isSLNOColumn(col: number): boolean {
    return col === this.premiumReportService.CONST_SLNO_COLUMN &&
           col < this.premiumReportService.FIXED_COLUMNS;
  }

  private isValidState(stateCode, stateDesc, sheet) {
    stateDesc = this.adjustStateDescription(stateCode, stateDesc, sheet);

    const rowInfo = this.rows.find((p) => p.Code === stateCode);
    if (!rowInfo || rowInfo.length === 0) {
      this.showError(`Not able to fetch State information. State Code - ${stateCode}`);
      return false;
    }

    if (rowInfo.Name === stateDesc) {
      return true;
    } else {
      this.showError(
        `State details in position [${stateCode}] is invalid. Please use the template file for upload.`
      );
      return false;
    }
  }

  private adjustStateDescription(stateCode, stateDesc, sheet): string {
    if (stateCode === this.premiumReportService.userdefined_row_code && stateDesc === 'Total User Defined Columns-Suppl.') {
      return 'Total User Defined Columns: Non-Admitted';
    }

    if (sheet === 0 && stateCode === this.premiumReportService.userdefined_row_code && stateDesc === 'Total User Defined Columns' ) {
        return 'Total User Defined Columns: Non-Admitted';
    }

    if (sheet === 1) {
      if (stateCode === this.premiumReportService.userdefined_row_code && stateDesc === 'Total User Defined Columns: Non-Admitted.') {
        return 'Total User Defined Columns: Non-Admitted';
      }
      if (stateCode === this.premiumReportService.supplemental_row_code && (stateDesc == null || stateDesc === '')) {
        return Labels.premium.supplementalVolume;
      }
    }

    return stateDesc;
  }

  public downloadData(isPDF) {
    if (this.isDirty) {
      this.confirmDialogService.confirmThis_withClose(
        'Premium Report',
        'Do you want to save changes?',
        () => {
          this.updatePremiumDetails();
          this.download(isPDF);
        },
        () => {
          this.store.dispatch(
            premiumReportActions.setGridClean({ grid: this.premium_type })
          );
          this.Clear(true);
          this.download(isPDF);
        },
        () => {
          return;
        }
      );
    } else {
      this.download(isPDF);
    }
  }

  public download(isPDF) {
    if (isPDF) {
      this.generatePDF();
    } else {
      this.isDownloading = true;
      setTimeout(() => {
        if (this.isLegacyDownload) {
          this.exportExcel();
        } else {
          this.exportExcelWithData();
        }
      }, 100);
    }
  }

  public exportExcel() {
    const workbook = this.initializeWorkbook();
    const worksheet = this.setupWorksheet(workbook);

    this.WriteColumnHeadersToExcel(worksheet);
    this.store
      .select(currentGridDataSelector(this.premium_type))
      .pipe(
        take(1),
        map((x) => JSON.parse(JSON.stringify(x))),
        withLatestFrom(
          this.direct_premium$,
          this.supplemental_premium$,
          this.userdefined_premium_direct$,
          this.userdefined_premium_columns$,
          this.userdefined_premium_supplemental$
        )
      )
      .subscribe(
        ([
          data,
          direct_premium,
          supplemental_premium,
          userdefined_premium_direct,
          userdefined_premium_columns,
          userdefined_premium_supplemental,
        ]) => {
          this.populateWorksheet(
          worksheet,
          data,
          direct_premium,
          supplemental_premium,
          userdefined_premium_direct,
          userdefined_premium_columns,
          userdefined_premium_supplemental
        );

          this.finalizeWorkbook(workbook);
        }
      );
  }

  public exportExcelWithData() {
    this.companyService.getPremiumReportTemplateFile('Template.xlsx').subscribe({
      next: (resp) => {
        if (resp['message'] === 'Success') {
          const fileUrl = resp['data'];
  
          // Fetch the file from the S3 URL
          ExcelUtility.loadFromUrl(fileUrl).then((workbook) => {
            this.processWorkbookWithData(workbook);
            workbook.setCurrentFormat(WorkbookFormat.Excel2007);
            ExcelUtility.save(workbook, 'Template');
            this.isDownloading = false;
          }
        );
          
        } else {
          console.error('Failed to fetch the template file.');
          this.router.navigate(['/apifailure']);
        }
      },
      error: () => {
        console.error('Error in downloadtemplate API call.');
        this.router.navigate(['/apifailure']);
      },
    });
  }

  public processWorkbookWithData(workbook: Workbook) {
    this.processWorksheetWithData(workbook, Labels.premium.directPlural, 'D');
    this.processWorksheetWithData(workbook, Labels.premium.supplementalPlural, 'S');
  }

  public processWorksheetWithData(workbook: Workbook, sheetName: string, premiumType: 'D' | 'S') {
    const worksheet = workbook.worksheets().item(sheetName);
  
    this.store
      .select(currentGridDataSelector(premiumType))
      .pipe(take(1))
      .subscribe((data) => {
        // Write data to the worksheet
        for (let row = 0; row < data.length; row++) {
          for (let col = 0; col < this.columns.length; col++) {
            const cell = worksheet.rows(row + 1).cells(col);
  
            // Check if the cell already contains a formula
            if (cell.formula || cell.cellFormat.locked || row == 63) {
              // Skip overwriting the cell if it contains a formula
              continue;
            } 
            // Write the value to the cell if no formula exists
            cell.value = data[row][col];
          }
        }
      });
  }


  private initializeWorkbook(): Workbook {
    const workbook = new Workbook();
    const font: IWorkbookFont = workbook.styles().normalStyle.styleFormat.font;
    font.name = 'Arial Unicode MS';
    font.height = 10 * 20;
    return workbook;
  }

  private setupWorksheet(workbook: Workbook): any {
    const sheetname = this.premium_type == 'D' ? Labels.premium.directPlural : Labels.premium.supplementalPlural;
    const worksheet = workbook.worksheets().add(sheetname);

    worksheet.displayOptions.panesAreFrozen = true;
    worksheet.displayOptions.frozenPaneSettings.frozenRows = 1;
    worksheet.displayOptions.frozenPaneSettings.frozenColumns = this.premiumReportService.FIXED_COLUMNS;

    return worksheet;
  }
  private populateWorksheet(
    worksheet: any,
    data: any[],
    direct_premium: any[],
    supplemental_premium: any[],
    userdefined_premium_direct: any[],
    userdefined_premium_columns: any[],
    userdefined_premium_supplemental: any[]
  ): void {
    for (let row = 0; row < data.length; row++) {
      for (let col = 0; col < this.columns.length; col++) {
        const premium_data = {
          direct_premium,
          supplemental_premium,
          userdefined_premium_direct,
          userdefined_premium_columns,
          userdefined_premium_supplemental,
        };
        this.processCell(
          worksheet,
          data,
          row,
          col,
          premium_data
        );
      }
    }
  }

  private processCell(
    worksheet: any,
    data: any[],
    row: number,
    col: number,
    premium_data: any
  ): void {
    const columnInfo = this.columns[col];
    const cell = worksheet.rows(row + 1).cells(col);

    if (col === 0) {
      cell.cellFormat.fill = CellFill.createSolidFill('#6EA3CC');
    }

    if (columnInfo.columnNumber === 0 || columnInfo.columnNumber === 2) {
      cell.value = String(data[row][col]);
    } else {
      cell.value = data[row][col];
      cell.cellFormat.formatString = '#,##0';
    }

    this.applyCellFormatting(
      cell,
      columnInfo,
      data,
      row,
      col,
      premium_data
    );
  }

  private applyCellFormatting(
    cell: any,
    columnInfo: any,
    data: any[],
    row: number,
    col: number,
    premium_data : any
  ): void {
    const isLastCell = this.isLastCell(columnInfo, data, row);

    if (this.isTotalRowData(data, row, col)) {
      this.formatTotalRow(cell, data, row, col);
    }

    if (columnInfo?.cellTypeId === 'C') {
      this.applyFormulaAndStyle(cell, columnInfo, row, isLastCell, premium_data);
    }

    if (this.shouldClearLastColumnValue(columnInfo, data, row)) {
      cell.value = '';
    }

    if (this.shouldClearSupplementalOrAssumedValues(columnInfo, data, row, cell)) {
      cell.value = '';
    }

    if (this.IsExclusive(data[row], columnInfo.columnNumber)) {
      this.applyExclusiveCellStyle(cell);
    }
  }

  private applyFormulaAndStyle(
    cell: any,
    columnInfo: any,
    row: number,
    isLastCell: boolean,
    premium_data: any
  ): void {
    if (columnInfo.cellformulae?.length > 0) {
      const formula = this.getFormula(
        columnInfo,
        row + 2,
        true,
        isLastCell,
        premium_data.userdefined_premium_direct,
        premium_data.userdefined_premium_columns,
        premium_data.userdefined_premium_supplemental
      );
      cell.applyFormula(formula);
    }
    cell.cellFormat.fill = CellFill.createSolidFill('#CECED2');
    this.setCellBorder(cell, '#000000');
  }

  private shouldClearLastColumnValue(
    columnInfo: any,
    data: any[],
    row: number
  ): boolean {
    return (
      columnInfo.columnNumber === this.columns.length - 1 &&
      (data[row][this.premiumReportService.CONST_STATECODE_COLUMN] ===
        this.premiumReportService.userdefined_row_code ||
        data[row][this.premiumReportService.CONST_STATECODE_COLUMN] ===
        this.premiumReportService.supplemental_row_code)
    );
  }

  private shouldClearSupplementalOrAssumedValues(
    columnInfo: any,
    data: any[],
    row: number,
    cell: any
  ): boolean {
    return (
      (data[row][this.premiumReportService.CONST_STATECODE_COLUMN] ===
        this.premiumReportService.AssumedFromNonAffiliates_row_code ||
        data[row][this.premiumReportService.CONST_STATECODE_COLUMN] ===
        this.premiumReportService.supplemental_row_code) &&
      columnInfo.columnNumber >= this.premiumReportService.FIXED_COLUMNS &&
      (columnInfo.cellTypeId === 'D' ||
        columnInfo.columnNumber === this.columns.length - 1) &&
      (cell.value == null || cell.value === 0)
    );
  }

  private applyExclusiveCellStyle(cell: any): void {
    cell.cellFormat.fill = CellFill.createSolidFill('#BADDFF');
    this.setCellBorder(cell, '#000000');
  }

  private isLastCell(columnInfo: any, data: any[], row: number): boolean {
    return (
      columnInfo.columnNumber === this.columns.length - 1 &&
      data[row][this.premiumReportService.CONST_STATECODE_COLUMN] ===
        this.premiumReportService.total_row_code
    );
  }

  private isTotalRowData(data: any[], row: number, col: number): boolean {
    return (
      this.premiumReportService.IsTotalRowData(
        parseInt(data[row][this.premiumReportService.CONST_ROW_NUMBER_COLUMN])
      ) && col >= this.premiumReportService.FIXED_COLUMNS
    );
  }

  private formatTotalRow(cell: any, data: any[], row: number, col: number): void {
    cell.cellFormat.fill = CellFill.createSolidFill('#CECED2');
    cell = this.setCellBorder(cell, '#000000');
    const rowformula = this.premiumReportService.GetTotalRowFormula(
      parseInt(data[row][this.premiumReportService.CONST_ROW_NUMBER_COLUMN])
    );
    if (rowformula.trim().length > 0) {
      const formulastring = this.getRowFormula(rowformula, row, col);
      cell.applyFormula(formulastring);
    }
  }
  private finalizeWorkbook(workbook: Workbook): void {
    workbook.setCurrentFormat(WorkbookFormat.Excel2007);
    ExcelUtility.save(workbook, 'Premium Report');
    this.isDownloading = false;
  }

  private getRowFormula(rowInfo, rowIndex, colIndex) {
    let formula = '';
    if (rowInfo.indexOf(',') > 0) {
      let split = rowInfo.split(',');
      let formulastring = [];
      for (const element of split) {
        formulastring.push(
          this.getRowFormulaString(element, rowIndex, colIndex)
        );
      }
      formula = '=' + formulastring.join('+');
    } else {
      formula = '=' + this.getRowFormulaString(rowInfo, rowIndex, colIndex);
    }
    return formula;
  }

  private setCellBorder(cell, colString) {
    let color = new Color();
    color.colorString = colString;
    cell.cellFormat.leftBorderColorInfo = new WorkbookColorInfo(color);
    cell.cellFormat.leftBorderStyle = CellBorderLineStyle.Default;
    cell.cellFormat.topBorderColorInfo = new WorkbookColorInfo(color);
    cell.cellFormat.topBorderStyle = CellBorderLineStyle.Default;
    cell.cellFormat.bottomBorderColorInfo = new WorkbookColorInfo(color);
    cell.cellFormat.bottomBorderStyle = CellBorderLineStyle.Default;
    cell.cellFormat.rightBorderColorInfo = new WorkbookColorInfo(color);
    cell.cellFormat.rightBorderStyle = CellBorderLineStyle.Default;
    return cell;
  }

  private WriteColumnHeadersToExcel(worksheet) {
    const white = new Color();
    white.colorString = '#FFFFFF';

    for (let col = 0; col < this.columns.length; col++) {
      let cell = worksheet.rows(0).cells(col);
      const isFirstColumn = col === 0;

      worksheet.columns(col).setWidth(isFirstColumn ? 50 : 150, 3);
      cell.value = this.columns[col].columnName;

      cell.cellFormat.fill = CellFill.createSolidFill('#6EA3CC');
      cell.cellFormat.alignment = HorizontalCellAlignment.Center;
      cell.cellFormat.verticalAlignment = VerticalCellAlignment.Center;

      const fontInfo = cell.cellFormat.font;
      fontInfo.colorInfo = new WorkbookColorInfo(white);
      fontInfo.bold = true;

      this.setCellBorder(cell, '#C0C0C0');
    }
  }

  private getFormula(
    columnInfo,
    rowIndex,
    IsExcelExport,
    IsLastCell,
    userdefined_premium,
    userdefined_premium_columns,
    userdefined_premium_supplemental
  ) {
    if (!columnInfo?.cellformulae?.length) {
      return '';
    }

    const formula = columnInfo.cellformulae.indexOf(',') > 0
      ? this.buildComplexFormula(columnInfo, rowIndex, IsExcelExport, IsLastCell, userdefined_premium, userdefined_premium_columns, userdefined_premium_supplemental)
      : this.buildSimpleFormula(columnInfo, rowIndex, IsExcelExport);

    return formula;
  }

  private buildComplexFormula(
    columnInfo,
    rowIndex,
    IsExcelExport,
    IsLastCell,
    userdefined_premium,
    userdefined_premium_columns,
    userdefined_premium_supplemental
  ) {
    const split = columnInfo.cellformulae.split(',');
    const formulastring = split.map(element =>
      this.premiumReportService.getFormulaString(element, rowIndex, IsExcelExport)
    );

    let formula = '=' + formulastring.join('+');

    if (IsExcelExport && !IsLastCell) {
      formula = this.appendAdditionalValues(
        formula,
        columnInfo,
        rowIndex,
        userdefined_premium,
        userdefined_premium_columns,
        userdefined_premium_supplemental
      );
    }

    return formula;
  }

  private buildSimpleFormula(columnInfo, rowIndex, IsExcelExport) {
    return '=' + this.premiumReportService.getFormulaString(columnInfo.cellformulae, rowIndex, IsExcelExport);
  }

  private appendAdditionalValues(
    formula,
    columnInfo,
    rowIndex,
    userdefined_premium,
    userdefined_premium_columns,
    userdefined_premium_supplemental
  ) {
    if (this.premium_type === 'D' && columnInfo.columnNumber === this.columns.length - 1) {
      formula = this.appendDirectPremiumValues(formula, rowIndex, columnInfo, userdefined_premium, userdefined_premium_columns);
    } else if (this.premium_type === 'S') {
      formula = this.appendSupplementalPremiumValues(formula, rowIndex, userdefined_premium_supplemental, userdefined_premium_columns);
    }
    return formula;
  }

  private appendDirectPremiumValues(
    formula,
    rowIndex,
    columnInfo,
    userdefined_premium,
    userdefined_premium_columns
  ) {
    const supplementalpremium = this.supplemental_premium[rowIndex - 2][columnInfo.columnNumber];
    if (supplementalpremium != null) {
      formula += '+' + supplementalpremium;
    }

    const userdefinedpremiumValue = userdefined_premium[rowIndex - 2][userdefined_premium_columns.length - 1];
    if (userdefinedpremiumValue != null && userdefinedpremiumValue != undefined) {
      formula += '+' + userdefinedpremiumValue;
    }

    return formula;
  }

  private appendSupplementalPremiumValues(
    formula,
    rowIndex,
    userdefined_premium_supplemental,
    userdefined_premium_columns
  ) {
    const udsupplemental = userdefined_premium_supplemental[rowIndex - 2][userdefined_premium_columns.length - 1];
    if (udsupplemental != null && udsupplemental != undefined) {
      formula += '+' + udsupplemental;
    }

    return formula;
  }

  private getRowFormulaString(formulaVal, rowIndex, colIndex) {
    const [startCol, endCol] = formulaVal.split(':');
    const adjustedStartCol = this.getColName(colIndex, startCol - 4);
    const adjustedEndCol = this.getColName(colIndex, endCol - 4);
    return `Sum(${adjustedStartCol}:${adjustedEndCol})`;
  }

  generatePDF() {
    console.log("Inside generate method.");
    (this.premium_type == 'D'
      ? this.direct_premium$
      : this.supplemental_premium$
    ).pipe(first()).subscribe((premium) => {
      this.isLoading = true;
      const temp_rows = this.rows.filter((row) => row.cellTypeId === 'C');
      const result = cleanPremiumData(premium, this.columns);

      if (result.updatedColumnNames.length < 4) {
        this.isLoading = false;
        this.toastService.reset();
        this.toastService.show('No premiums have been entered yet.', { classname: 'bg-danger text-light', delay: 3000 });
        window.scrollTo(0, 0);
        return true;
      }

      const premiumtype = this.premium_type == 'D' ? '' : ' (' + Labels.premium.supplementalPlural + ')';
      const params: printParams = new printParams(
        result.updatedColumnNames,
        temp_rows,
        result.filteredData,
        [1, 2],
        13,
        this.currentYear,
        this.prfNumber,
        this.prfName,
        false,
        null,
        premiumtype,
        result.cleanedData
      );
      this.pdfService.params = params;
      this.pdfService.generate();
      this.isLoading = false;
    });
  }

  openUploadPremium() {
    const modalRef = this.modalService.open(UploadPremiumComponent);
    modalRef.result.then((result) => {
      if (result) {
        this.uploadExcelDataToGrid(result);
      }
    });
  }

  openDownloadPremium() {
    const modalRef = this.modalService.open(DownloadPremiumComponent);
    modalRef.componentInstance.exportExcel.subscribe((isLegacyDownload) => {
      this.isLegacyDownload = isLegacyDownload;
      this.downloadData(false);
    });
  }

  handleClickOutside() {
    this.store.dispatch(GridActions.applyInitialStates());
  }

  onGridConfigButtonClick() {
    this.store.dispatch(GridActions.toggleGridConfig());
  }

  public toggleConsolidatedOrDetailView(event: MatSlideToggleChange) {
    if (event.checked) {
      this.store.dispatch(premiumReportActions.enableConsolidatedView());
    } else {
      this.store.dispatch(premiumReportActions.enableDetailedView());
    }
  }

  private getColName(colIndex, rowIndex) {
    let colName = '';

    while (colIndex >= 0) {
      colName = String.fromCharCode((colIndex % 26) + 65) + colName;
      colIndex = Math.floor(colIndex / 26) - 1;
    }

    if (colName.length > 0) {
      colName += rowIndex;
    }

    return colName;
  }

  private IsExclusive = (rowData: any, columnKey: any): boolean => {
    const columnInfo = this.columns.find(
      (column) => column.Number == columnKey - 2
    );

    if (columnInfo) {
      const rows = columnInfo.ExclRows;
      if (rows != null) {
        const rowSplit = rows.split(',');
        return rowSplit.includes(String(rowData[0]));
      }
    }
    return false;
  };

  private switchTab(tabName) {
    this.store.dispatch(
      premiumReportActions.setPremiumType({
        premiumType: tabName === 'direct' ? 'D' : 'S',
      })
    );
  }

  public showtab(tabName) {
    // Check if the user clicks the same tab
    if (this.shouldSkipTabSwitch(tabName)) {
      return;
    }

    // Check if the grid is in valid state
    if (!this.isvalidgrid) {
      this.store.dispatch(
        premiumReportActions.setGridValidity({
          grid: this.premium_type,
          validity: true,
        })
      );
      return;
    }
    this.switchTabAndRefresh(tabName);
  }

  private shouldSkipTabSwitch(tabName: string): boolean {
    return (
      (this.premium_type === 'D' && tabName === 'direct') ||
      (this.premium_type === 'S' && tabName === 'supplemental')
    );
  }

  private showSaveChangesDialog(tabName: string): void {
    this.confirmDialogService.confirmThis_withClose(
      'Premium Report',
      'Do you want to save changes?',
      () => {
        this.handleSaveChangesConfirmation(tabName);
      },
      () => {
        this.handleCancelChangesConfirmation(tabName);
      },
      () => {
        // Close button
        return;
      }
    );
  }

  private handleSaveChangesConfirmation(tabName: string): void {
    this.updatePremiumDetails(tabName == 'direct' ? 'S' : 'D');
    this.switchTabAndRefresh(tabName);
  }

  private handleCancelChangesConfirmation(tabName: string): void {
    this.store.dispatch(premiumReportActions.refreshDirectWithCopy());
    this.store.dispatch(premiumReportActions.refreshSupplementalWithCopy());
    this.switchTabAndRefresh(tabName);
  }

  private switchTabAndRefresh(tabName: string): void {
    this.switchTab(tabName);
  }
  removePrevAlerts() {
    const toasts = this.toastService.toasts.slice().reverse();
    for (const toast of toasts) {
      this.toastService.remove(toast);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.next();
    this.subscriptions.complete();
    this.Clear()
  }

  private validateTemplateStructure(worksheet, expectedRows: number, expectedColumns: number): boolean {
    let actualRowCount = 0
    let actualColumnCount =0
    let rowIndex = 1;
    let colIndex =0;

    while (worksheet.rows(rowIndex).cells(0).value != null) {
          actualRowCount++;
          rowIndex++;
        }

    while (worksheet.rows(0).cells(colIndex).value != null) {
      actualColumnCount++
      colIndex++
    }

    if (actualRowCount !== expectedRows) {
      this.showError(
        `Invalid number of rows. Expected ${expectedRows+1}, but found ${actualRowCount+1}. Please use the correct template.`
      );
      return false;
    }

    if (actualColumnCount !== expectedColumns) {
      this.showError(
        `Invalid number of columns. Expected ${expectedColumns}, but found ${actualColumnCount}. Please use the correct template.`
      );
      return false;
    }
    return true;
  }

  private validateA1Cell(workbook): boolean {
    const expectedValue = "PRF Original";
    const sheetCount = workbook.worksheets().count;

    for (let sheet = 0; sheet < sheetCount; sheet++) {
      const worksheet = workbook.worksheets(sheet);
      const a1Value = worksheet.rows(0).cells(0).value;

      if (a1Value !== expectedValue) {
        this.showPageWarning = false;
        const errorMessage = "The template you used for upload is invalid. Please use the `Download Template` button to acquire this year's version";
        this.showError(errorMessage);
        return false;
      }
    }
    return true;
  }

  private validateFormulaCells(worksheet, lockedColumns, lockedRows): boolean {
    if (this.isNonAdmittedSheetName(worksheet.name)) {
      lockedRows = lockedRows.filter(row => row !== 65);
    }
    for (let row = 1; row <= this.rows.length; row++) {
      if (!this.validateLockedColumns(worksheet, row, lockedColumns)) {
        return false;
      }

      if (lockedRows.includes(row) && !this.validateLockedRows(worksheet, row)) {
        return false;
      }
    }
    return true;
  }

  private validateLockedColumns(worksheet, row: number, lockedColumns: number[]): boolean {
    for (let col of lockedColumns) {
      if (this.isExceptionCell(row, col)) {
        if (!this.isValidExceptionCell(worksheet, row, col)) {
          return false;
        }
        continue;
      }

      const cell = worksheet.rows(row).cells(col);
      if (!cell.formula) {
        this.showError(
          `Invalid data! Manually entered value found in ${worksheet.name} locked column ${col + 1} at row ${row + 1}. The value should be formula-calculated.`
        );
        return false;
      }
    }
    return true;
  }

  private validateLockedRows(worksheet, row: number): boolean {
    for (let col = 3; col < this.columns.length; col++) {
      if (this.isExceptionCell(row, col)) {
        continue;
      }

      const cell = worksheet.rows(row).cells(col);
      if (!cell.formula) {
                this.showError(
          `Invalid data! Manually entered value found in ${worksheet.name} locked row ${row + 1} at column ${col + 1}. The value should be formula-calculated.`
        );
        return false;
      }
    }
    return true;
  }

  private isExceptionCell(row: number, col: number): boolean {
    return (
      this.EXCEPTED_COLUMNS.includes(col) &&
      this.premiumReportService.EXCEPTED_ROWS.includes(row)
    );
  }

  private isValidExceptionCell(worksheet, row: number, col: number): boolean {
    const cell = worksheet.rows(row).cells(col);
    if (cell.value !== null && cell.value !== undefined && cell.value != 0) {
      this.showError(
        `Invalid data! Manually entered value found in ${worksheet.name} locked column ${col + 1} at row ${row + 1}. It is a locked cell.`
      );
      return false;
    }
    return true;
  }

  private validatelockedCells(worksheet, lockedColumns, lockedRows): boolean {
    if (this.isAdmittedSheetName(worksheet.name)) {
      lockedRows = lockedRows.filter(row => row !== 65);
    }

    const isFormulaOrZeroRow = (row: number) =>
      this.premiumReportService.FORMULATED_ROWS.includes(row) ||
      this.premiumReportService.VALUE_ZERO_ROWS.includes(row);

    for (let row = 1; row <= this.rows.length; row++) {
      if (this.isAdmittedSheetName(worksheet.name) && !this.validateLockedColumn(worksheet, row, lockedColumns, isFormulaOrZeroRow)) {
        return false;
      }
      if (lockedRows.includes(row) && !this.validateLockedRow(worksheet, row)) {
        return false;
      }
      if (this.premiumReportService.VALUE_ZERO_ROWS.includes(row) && !this.validateZeroValueRow(worksheet, row)) {
        return false;
      }
    }
    return true;
  }

  private validateLockedColumn(worksheet, row: number, lockedColumns: number[], isFormulaOrZeroRow: (row: number) => boolean): boolean {
    for (let col of lockedColumns) {
      if (isFormulaOrZeroRow(row)) continue;
      const cell = worksheet.rows(row).cells(col);
      if (cell.value !== null && cell.value !== undefined) {
        console.log(cell.value);
        this.showError(
          'Invalid data! Manually entered value found in ' + worksheet.name +
          ' locked column ' + (col + 1) + ' at row ' + (row + 1) +
          '. It is a locked cell. '
        );
        return false;
      }
    }
    return true;
  }

  private validateLockedRow(worksheet, row: number): boolean {
    for (let col = 3; col <= this.columns.length; col++) {
      if (this.FORMULATED_COLUMNS.includes(col)) {
        continue;
      }
      const cell = worksheet.rows(row).cells(col);
      if (cell.value !== null && cell.value !== undefined) {
        console.log(cell.value);
        this.showError(
          'Invalid data! Manually entered value found in ' + worksheet.name +
          ' locked row ' + (row + 1) + ' at column ' + (col + 1) +
          '. It is a locked cell. '
        );
        return false;
      }
    }
    return true;
  }

  private validateZeroValueRow(worksheet, row: number): boolean {
    for (let col = 3; col < this.columns.length; col++) {
      if (this.FORMULATED_COLUMNS.includes(col)) continue;
      if (worksheet.rows(row).cells(col).value !== 0) {
        this.showError(
          'Invalid data! Manually entered value found in ' + worksheet.name +
          ' locked row ' + (row + 1) + ' at column ' + (col + 1) +
          '. It is a locked cell. '
        );
        return false;
      }
    }
    return true;
  }
  private convertTothousandsButtonClick(): void {
    this.converttothousandsService.confirmConvertToThousands(() => {
      this.convertTothousands();
    });
  }
  private convertTothousands(): void {
    setTimeout(() => {
    this.store
      .select(selectPremiumReportState)
      .pipe(take(1))
      .subscribe((data: PremiumReportState) => {
        const updatedData = { ...data };
        if(this.premium_type == 'D'){
        updatedData.premiumData.D.premiumGridData = updatedData.premiumData.D.premiumGridData.map((row: any) => {
          row = this.convertToThousandsCalculations(row);
          return row;
        });
        this.setDataForGrid(updatedData.premiumData.D.premiumGridData, 'D');
      }
        if(this.premium_type == 'S'){
        updatedData.premiumData.S.premiumGridData = updatedData.premiumData.S.premiumGridData.map((row: any) => {
          row = this.convertToThousandsCalculations(row);
          return row;
        });
        this.setDataForGrid(updatedData.premiumData.S.premiumGridData, 'S');
      }
      this.isDirty = true;
      this.store.dispatch(
        premiumReportActions.setGridDirty({ grid: this.premium_type })
      );
      
      });
    }, 500);
  }
  private convertToThousandsCalculations(row: any): any {
    if (typeof row === 'object' && row !== null) {
      Object.keys(row).forEach((key) => {
    if (typeof row[key] === 'number' && parseInt(key) >= 2) {
      row[key] = Math.round(row[key] / 1000);
    }
      });
    }
    return row;
  }

  private loadColumnConfig(): void {
    this.FORMULATED_COLUMNS = [];
    this.LOCKED_COLUMNS = [];
    this.EXCEPTED_COLUMNS = [];
    this.store
      .select(selectDirectPremiumColumnsWithTotal)
      .pipe(filter(columns=>columns?.length!=0),take(1))
      .subscribe((columns: any[]) => {
        this.FORMULATED_COLUMNS = columns
          .filter(col => col?.properties?.includes('column_formula'))
          .map(col => Number(col.id) + 2);

        this.LOCKED_COLUMNS = columns
          .filter(col => col?.properties?.includes('direct_locked'))
          .map(col => Number(col.id) + 2);

        this.EXCEPTED_COLUMNS = columns
          .filter(col => col?.properties?.includes('total_column'))
          .map(col => Number(col.id) + 2);
      });
  }
}
